import styled from "styled-components";

export const AddOtherFilter = styled.div`
  display: flex;
  align-items: center;
`;
